import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import {addGlobalError} from "../../../../actions/globalerror";

class Signups extends React.Component {
    static propTypes = {
        data: PropTypes.array.isRequired,
        setEditMode: PropTypes.func.isRequired,
        updateRow: PropTypes.func.isRequired,
        deleteRow: PropTypes.func.isRequired,
        acceptRow: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            editIx: null,
        };
    }

    fields = [];
    render() {
        return <div>
            <table className="data-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>Fejltekst</th>
                        <th className="center">Uge</th>
                        <th className="center">Foren</th>
                        <th className="center">KFK</th>
                        <th className="center">Slag</th>
                        <th>Due</th>
                        <th className="center">Køn</th>
                        <th className="center">Sport</th>
                        <th className="center">Sek.A</th>
                        <th className="center">Sek.B</th>
                        <th className="center">Grp.A</th>
                        <th className="center">Grp.B</th>
                        <th className="center">Pulje</th>
                        <th className="center">Elite</th>
                        <th className="center">Zone</th>
                        <th className="center">DM</th>
                        <th className="center">Mark.</th>
                        <th>Forening</th>
                        <th>Hjemk.</th>
                        <th className="center">Døgn</th>
                        <th className="center">Ur</th>
                        <th>Vers.</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.data.map((row, ix) => ix === this.state.editIx ? <tr key={ix} className="edit-row">
                        <th scope="row" style={{minWidth: '80px'}}>
                            <i className="fa fa-save clickable" title="Gem" onClick={() => {
                                if (this.allInputValid()) {
                                    this.props.updateRow({Key: row.Key}, {
                                        Uge: this.state.Uge === '' ? null : this.state.Uge,
                                        Forening: this.state.Forening === '' ? null : this.state.Forening,
                                        KFK: this.state.KFK === '' ? null : this.state.KFK,
                                        Slag: this.state.Slag === '' ? null : this.state.Slag,
                                        Ringnummer: this.state.Ringnummer === '' ? null : this.state.Ringnummer,
                                        Koen: this.state.Koen === '' ? null : this.state.Koen,
                                        Sportsdue: this.state.Sportsdue,
                                        SektionA: this.state.SektionA === '' ? 0 : Number(this.state.SektionA),
                                        SektionB: this.state.SektionB === '' ? 0 : Number(this.state.SektionB),
                                        GruppeA: this.state.GruppeA === '' ? 0 : Number(this.state.GruppeA),
                                        GruppeB: this.state.GruppeB === '' ? 0 : Number(this.state.GruppeB),
                                        Pulje: this.state.Pulje,
                                        Elite: this.state.Elite,
                                        Z_Spil: this.state.Z_Spil,
                                        DM: this.state.DM,
                                        DueMarkering: this.state.DueMarkering,
                                        DueMarkeringT: this.state.DueMarkering === null || this.state.DueMarkering === 0 ? null : (row.DueMarkeringT === null || row.DueMarkeringT === '' ? 'X' : row.DueMarkeringT),
                                        ForeningskrydsT: this.state.ForeningskrydsT === '' ? null : this.state.ForeningskrydsT,
                                        Hjemkomst: this.state.Hjemkomst,
                                        Doegn: this.state.Doegn === '' ? null : Number(this.state.Doegn),
                                        Urnr: this.state.Urnr === '' ? null : Number(this.state.Urnr),
                                    }, () => {
                                        NotificationManager.success("Rækken " + this.state.Ringnummer + " (KFK " + this.state.KFK + "/Uge " + this.state.Uge + ") er opdateret.", "Opdatering", 4000);
                                        this.setState({editIx: null});
                                        this.props.setEditMode(false);
                                    });
                                } else {
                                    this.fields.forEach((field) => {
                                        field.setState({visited: true});
                                    });
                                }
                            }}/>
                            <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                                this.setState({editIx: null});
                                this.props.setEditMode(false);
                            }}/>
                        </th>
                        <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="Uge" id="Uge" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,2}"}]} value={this.state.Uge}
                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[0] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="Forening" id="Forening" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Forening}
                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[1] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="KFK" id="KFK" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.KFK}
                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[2] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="Slag" id="Slag" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Slag}
                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[3] = instance; }}
                            />
                        </td>
                        <td style={{minWidth: '100px'}}>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field150" containerClassName="display-inline-block"
                                              name="Ringnummer" id="Ringnummer" maxLength="11" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}"}]} value={this.state.Ringnummer}
                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[4] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="Koen" id="Koen" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[AUX]"}]} value={this.state.Koen}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onUpperCaseFieldChange}
                                              ref={instance => { this.fields[5] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <input type="checkbox" name="Sportsdue" id="Sportsdue" checked={this.state.Sportsdue !== null && this.state.Sportsdue !== 0} onChange={this.onCheckFieldChange}/>
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="SektionA" id="SektionA" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[1-6]"}]} value={this.state.SektionA}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onSecGrpChange}
                                              ref={instance => { this.fields[6] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="SektionB" id="SektionB" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[1-6]"}]} value={this.state.SektionB}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onSecGrpChange}
                                              ref={instance => { this.fields[7] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="GruppeA" id="GruppeA" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[1-6]"}]} value={this.state.GruppeA}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onSecGrpChange}
                                              ref={instance => { this.fields[8] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="GruppeB" id="GruppeB" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[1-6]"}]} value={this.state.GruppeB}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onSecGrpChange}
                                              ref={instance => { this.fields[9] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <input type="checkbox" name="Pulje" id="Pulje" checked={this.state.Pulje !== null && this.state.Pulje !== 0} onChange={this.onCheckFieldChange}/>
                        </td>
                        <td className="center">
                            <input type="checkbox" name="Elite" id="Elite" checked={this.state.Elite !== null && this.state.Elite !== 0} onChange={this.onCheckFieldChange}/>
                        </td>
                        <td className="center">
                            <input type="checkbox" name="Z_Spil" id="Z_Spil" checked={this.state.Z_Spil !== null && this.state.Z_Spil !== 0} onChange={this.onCheckFieldChange}/>
                        </td>
                        <td className="center">
                            <input type="checkbox" name="DM" id="DM" checked={this.state.DM !== null && this.state.DM !== 0} onChange={this.onCheckFieldChange}/>
                        </td>
                        <td className="center">
                            <input type="checkbox" name="Duemarkering" id="Duemarkering" checked={this.state.Duemarkering !== null && this.state.Duemarkering !== 0} onChange={this.onCheckFieldChange}/>
                        </td>
                        <td>{
                            <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field100" containerClassName="display-inline-block"
                                              name="ForeningskrydsT" id="ForeningskrydsT" maxLength="10" value={this.state.ForeningskrydsT}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => {
                                                  this.fields[10] = instance;
                                              }}
                            />
                        }</td>
                        <td>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                              name="Hjemkomst" id="Hjemkomst" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}\\:[0-9]{2}\\:[0-9]{2}"}]} value={this.state.Hjemkomst}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[11] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="Doegn" id="Doegn" value={this.state.Doegn}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[12] = instance; }}
                            />
                        </td>
                        <td className="center">
                            <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="Urnr" id="Urnr" value={this.state.Urnr}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[13] = instance; }}
                            />
                        </td>
                        <td>{row.Programversion === null ? '' : row.Programversion}</td>
                    </tr> : <tr key={ix}>
                        <th scope="row" style={{minWidth: '80px'}}>
                            <i className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                                if (this.state.editIx === null) this.setState({
                                    Uge: row.Uge === null ? '' : row.Uge,
                                    Forening: row.Forening === null ? '' : row.Forening,
                                    KFK: row.KFK === null ? '' : row.KFK,
                                    Slag: row.Slag === null ? '' : row.Slag,
                                    Ringnummer: row.Ringnummer === null ? '' : row.Ringnummer,
                                    Koen: row.Koen === null ? '' : row.Koen,
                                    Sportsdue: row.Sportsdue,
                                    SektionA: row.SektionA === null || row.SektionA === 0 ? '' : String(row.SektionA),
                                    SektionB: row.SektionB === null || row.SektionB === 0 ? '' : String(row.SektionB),
                                    GruppeA: row.GruppeA === null || row.GruppeA === 0 ? '' : String(row.GruppeA),
                                    GruppeB: row.GruppeB === null || row.GruppeB === 0 ? '' : String(row.GruppeB),
                                    Pulje: row.Pulje,
                                    Elite: row.Elite,
                                    Z_Spil: row.Z_Spil,
                                    DM: row.DM,
                                    DueMarkering: row.DueMarkering,
                                    ForeningskrydsT: row.ForeningskrydsT === null ? '' : row.ForeningskrydsT,
                                    Hjemkomst: row.Hjemkomst === null ? '' : moment.utc(row.Hjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss'),
                                    Doegn: row.Doegn === null ? '' : String(row.Doegn),
                                    Urnr: row.Urnr === null ? '' : String(row.Urnr),
                                    editIx: ix,
                                });
                                this.props.setEditMode(true);
                            }}/>
                            <i className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet række" onClick={() => {
                                if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at slette rækken <b>{row.Ringnummer} (KFK {row.KFK}/Uge {row.Uge})</b>?</span>, () => {
                                    this.props.deleteRow([{Key: row.Key}], () => {
                                        NotificationManager.success("Rækken " + row.Ringnummer + " (KFK " + row.KFK + "/Uge " + row.Uge + ") er slettet.", "Sletning", 4000);
                                    });
                                });
                            }}/>
                            <i className={"fa fa-check " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Accepter række" onClick={() => {
                                if (this.state.editIx === null) confirm("Accepter", <span>Ønsker du at acceptere rækken <b>{row.Ringnummer} (KFK {row.KFK}/Uge {row.Uge})</b>?</span>, () => {
                                    this.props.acceptRow([{Key: row.Key}], (response) => {
                                        if (response.failed.length > 0) this.props.dispatch(addGlobalError('Fejl ved accept', response.failed[0].msg, -1));
                                        else NotificationManager.success("Rækken " + row.Ringnummer + " (KFK " + row.KFK + "/Uge " + row.Uge + ") er accepteret.", "Accept", 4000);
                                    });
                                });
                            }}/>
                        </th>
                        <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                        <td className="center">{row.Uge === null ? '' : row.Uge}</td>
                        <td className="center">{row.Forening === null ? '' : row.Forening}</td>
                        <td className="center">{row.KFK === null ? '' : row.KFK}</td>
                        <td className="center">{row.Slag === null ? '' : row.Slag}</td>
                        <td style={{minWidth: '100px'}}>{row.Ringnummer === null ? '' : row.Ringnummer}</td>
                        <td className="center">{row.Koen === null ? '' : row.Koen}</td>
                        <td className="center">{row.Sportsdue === 0 || row.Sportsdue === null ? '' : 'X'}</td>
                        <td className="center">{row.SektionA === 0 || row.SektionA === null ? '' : row.SektionA}</td>
                        <td className="center">{row.SektionB === 0 || row.SektionB === null ? '' : row.SektionB}</td>
                        <td className="center">{row.GruppeA === 0 || row.GruppeA === null ? '' : row.GruppeA}</td>
                        <td className="center">{row.GruppeB === 0 || row.GruppeB === null ? '' : row.GruppeB}</td>
                        <td className="center">{row.Pulje === 0 || row.Pulje === null ? '' : 'X'}</td>
                        <td className="center">{row.Elite === 0 || row.Elite === null ? '' : 'X'}</td>
                        <td className="center">{row.Z_Spil === 0 || row.Z_Spil === null ? '' : 'X'}</td>
                        <td className="center">{row.DM === 0 || row.DM === null ? '' : 'X'}</td>
                        <td className="center">{row.DueMarkering === 0 || row.DueMarkering === null ? '' : 'X'}</td>
                        <td>{row.ForeningskrydsT === null ? '' : row.ForeningskrydsT}</td>
                        <td>{row.Hjemkomst === null ? '' : moment.utc(row.Hjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss')}</td>
                        <td className="center">{row.Doegn === null ? '' : String(row.Doegn)}</td>
                        <td className="center">{row.Urnr === null ? '' : String(row.Urnr)}</td>
                        <td>{row.Programversion === null ? '' : row.Programversion}</td>
                    </tr>)}
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onUpperCaseFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value.toUpperCase()});
    };

    onCheckFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.checked ? -1 : 0});
    };

    onSecGrpChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value >= '1' && e.target.value <= '6' ? e.target.value : ''});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getAllKeys = () => {
        return this.props.data.map(row => ({
            Key: row.Key
        }));
    };
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null, null, {withRef: true})(Signups);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/errorLists/subPages/Signups.js